import { disableScroll, enableScroll } from "../../components/_helpers.js";

export default class FilterWindow {

    private filterWindow: HTMLElement | null = null;
    private openMobileFiltersButtons: NodeListOf<HTMLElement> | null = null;
    private closeWindowButton: HTMLElement | null = null;

    async init(): Promise<void> {
        await this.initVariables();
        await this.filterWindowEvents();
        jQuery(document).on('ajaxComplete', () => this.scrollResultsIntoView());
    }

    async initVariables(): Promise<void> {
        this.filterWindow = document.querySelector('.filters-sidebar');
        this.openMobileFiltersButtons = document.querySelectorAll('.open-mobile-filters');
        this.closeWindowButton = document.querySelector('.close-mobile-filters');
    }

    async filterWindowEvents(): Promise<void> {
        const showResultsButton: HTMLElement | null = document.querySelector('.filters-show-results');

        if (!showResultsButton) return;

        showResultsButton.addEventListener('click', () => this.toggleWindow());

        if (!this.openMobileFiltersButtons) return;

        this.openMobileFiltersButtons.forEach((button: HTMLElement) => {
            button.addEventListener('click', () => this.openWindow());
        });

        if (!this.closeWindowButton) return;

        this.closeWindowButton.addEventListener('click', () => this.closeWindow());

    }

    async scrollResultsIntoView(): Promise<void> {
        const results: HTMLElement | null = document.querySelector('.products .scroll-offset');

        if (!results) return;

        results.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }

    async toggleWindow(): Promise<void> {
        if (!this.filterWindow) return;

        this.filterWindow.classList.contains('open') ? this.closeWindow() : this.openWindow();
    }

    async closeWindow(): Promise<void> {
        if (!this.filterWindow) return;

        this.filterWindow.classList.remove('open');
        enableScroll();
    }

    async openWindow(): Promise<void> {
        if (!this.filterWindow) return;

        this.filterWindow.classList.add('open');
        disableScroll();
    }
}